<div class="flex gap-4" [formGroup]="form()">
  <mat-form-field class="flex-1" subscriptSizing="dynamic">
    <mat-label>Agreement Holder</mat-label>
    <mat-select
      formControlName="provider"
      matTooltip="Whose Payee and Agreement numbers this form is claimed under"
    >
      <mat-option [value]="practitioner()">
        {{ practitioner().user.name }}
      </mat-option>
      <mat-option [value]="practice()">
        {{ practice().name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="flex-1" subscriptSizing="dynamic">
    <mat-label>Payee Number</mat-label>
    <input matInput type="text" formControlName="payeeNumber" required />
  </mat-form-field>

  <mat-form-field class="flex-1" subscriptSizing="dynamic">
    <mat-label>Agreement Number</mat-label>
    <input matInput type="text" formControlName="agreementNumber" required />
  </mat-form-field>
</div>
